// A <dialog> in the top layer paints above every z-index; popovers stack last-shown-wins.

const HOST_ID = 'ss-notification-host'

const HOST_STYLE = {
  position:   'fixed',
  inset:      'auto',
  top:        '0',
  left:       '0',
  width:      '0',
  height:     '0',
  margin:     '0',
  padding:    '0',
  border:     '0',
  overflow:   'visible',
  background: 'transparent'
}

let host = null

export const notificationHost = () => {
  if (host) return host

  host = document.getElementById(HOST_ID) || document.createElement('div')
  host.id = HOST_ID
  host.setAttribute('popover', 'manual')
  Object.assign(host.style, HOST_STYLE)

  if (!host.parentNode) document.body.appendChild(host)

  return host
}

export const raiseNotificationHost = () => {
  const element = notificationHost()

  if (typeof element.showPopover !== 'function') return

  const isOpen    = element.matches(':popover-open')
  const needsLift = isOpen && !!document.querySelector('dialog[open]')

  try {
    if (needsLift) element.hidePopover()
    if (!isOpen || needsLift) element.showPopover()
  } catch (err) {
  }
}

export default notificationHost
